const ProposerRegistry = require('./proposerRegistry.js');
const BuilderRegistry = require('./builderRegistry.js');
const ReporterRegistry = require('./reporterRegistry.js');
const PayoutPool = require('./payoutPool.js');

class PON {
    constructor(signer) {
        this.proposerRegistry = new ProposerRegistry(signer);
        this.builderRegistry = new BuilderRegistry(signer);
        this.reporterRegistry = new ReporterRegistry(signer);
        this.payoutPool = new PayoutPool(signer);
    }
}

module.exports = PON;